/*
 * PAWS & PEARLS — THE MUSE — SEVEN DISTANT SKY BALLOONS V1.3 — A TINY BIT MORE VERTICAL BOBBING
 * 27 October 2026 | MAGICAL MUSE WORLD unpublished duplicate theme ONLY
 *
 * SEPARATE ATMOSPHERIC LAYER: seven slow background balloons in the
 * existing Secret Sky. Reuses the FOUR previously approved WebP assets
 * via the READ-ONLY hidden #pp-muse-companion-assets Liquid configuration.
 * No other assets or code changes required.
 *
 * NEVER starts/pauses/retimes V18, changes .page-wrapper scrolling,
 * changes any Secret Sky/Cloud Veil dimensions, changes the four departing
 * companion balloons, music, sound controls, or pearl shower.
 * Rollback: remove this NEW script tag from theme.liquid.
 */
(function () {
  'use strict';
  var VERSION = '1.3-tiny-extra-vertical-bobbing';
  var ID = 'pp-muse-seven-distant-balloons-v1';
  var STYLE_ID = ID + '-style';
  var NS = 'ppMuseDistantSkyBalloons';
  var originalConfigId = 'pp-muse-companion-assets';
  var skyId = 'pp-muse-secret-sky';
  var instance = null;
  var resizeFrame = 0;

  // Coordinates are percentages of the TALL Secret Sky artwork, NOT of the
  // Muse balloon or browser viewport. This revised map relocates the left
  // foreground/atelier balloons to the open sea and distant skyline.
  // 'scale' sizes the WHOLE 700px transparent WebP box relative to its base.
  // Visible artwork occupies ~2/3 of that box's width, producing genuinely
  // distant silhouettes. The original WebPs are NOT altered or cropped.
  // V1.3: add just 2 px to the V1.2 vertical bob amplitude for each balloon.
  // Keep original positions, scale, horizontal drift, tilt and original image nodes.
  var specifications = Object.freeze([
    // Three tiny, slow, FAR balloons among the distant hills / high sky.
    {id:'B1', design:'ivory', x:44, y:14, scale:0.095, opacity:1, bobY:10, driftX:3, duration:22, delay:-4},
    {id:'B2', design:'pearl', x:74, y:18, scale:0.085, opacity:1, bobY:10, driftX:-3,duration:25, delay:-10},
    {id:'B3', design:'black', x:91, y:27, scale:0.110, opacity:1, bobY:12, driftX:-4,duration:24, delay:-7},
    // Two mid-distance balloons out over water, never in front of the atelier.
    {id:'B4', design:'rose', x:67, y:35, scale:0.130, opacity:1, bobY:15, driftX:5, duration:20, delay:-6},
    {id:'B5', design:'ivory',x:87, y:46, scale:0.135, opacity:1, bobY:15, driftX:-5,duration:21, delay:-12},
    // Two readable but STILL distant balloons lower over the bay.
    {id:'B6', design:'black',x:56, y:62, scale:0.165, opacity:1, bobY:20,driftX:6, duration:18, delay:-3},
    {id:'B7', design:'pearl',x:92, y:61, scale:0.155, opacity:1, bobY:18, driftX:-6,duration:19, delay:-9}
  ]);

  function report(message) {
    if (window.console && console.info) console.info('[P&P seven sky balloons] ' + message);
  }

  function getAssetUrls() {
    // Reuse the site's existing approved URL values. NEVER rewire its
    // departure logic or edit the hidden configuration element.
    var source = document.getElementById(originalConfigId);
    if (!source) return null;
    var data = source.dataset || {};
    var urls = {rose:data.rose,black:data.black,ivory:data.ivory,pearl:data.pearl};
    var names = ['rose','black','ivory','pearl'];
    for (var i=0;i<names.length;i++) {
      var url = urls[names[i]];
      if (typeof url !== 'string' || !(/^(https?:\/\/|\/)/.test(url))) return null;
    }
    return urls;
  }

  function cssText() {
    return [
      // Explicitly above the scene wallpaper, below all future creatures.
      'html.pp-muse-secret-sky-page #pp-muse-secret-sky #' + ID + '{',
      'position:absolute!important;inset:0!important;z-index:1!important;',
      'overflow:hidden!important;pointer-events:none!important;user-select:none!important;}',
      'html.pp-muse-secret-sky-page #' + ID + ' .pp-distant-sky-balloon{',
      'position:absolute!important;display:block;pointer-events:none!important;',
      'user-select:none!important;transform:translate(-50%,-50%)!important;}',
      'html.pp-muse-secret-sky-page #' + ID + ' .pp-distant-sky-balloon img{',
      'display:block!important;width:100%!important;height:auto!important;max-width:none!important;',
      'object-fit:contain!important;pointer-events:none!important;user-select:none!important;',
      '-webkit-user-drag:none;transform-origin:50% 58%;',
      'animation:pp-distant-balloon-bob var(--pp-duration) ease-in-out var(--pp-delay) infinite both;}',
      '@keyframes pp-distant-balloon-bob{',
      '0%,100%{transform:translate3d(0,0,0) rotate(0deg);}',
      '25%{transform:translate3d(var(--pp-drift),var(--pp-up),0) rotate(var(--pp-tilt));}',
      '55%{transform:translate3d(var(--pp-neg-drift),var(--pp-down),0) rotate(var(--pp-neg-tilt));}',
      '79%{transform:translate3d(var(--pp-drift-half),var(--pp-up-half),0) rotate(var(--pp-tilt-half));}',
      '}',
      // The full seven-balloon panorama is a desktop experience. Only three
      // are shown on small screens to keep the sky readable and performant.
      '@media(max-width:767px){',
      '#' + ID + ' .pp-distant-sky-balloon[data-balloon-id="B3"],',
      '#' + ID + ' .pp-distant-sky-balloon[data-balloon-id="B4"],',
      '#' + ID + ' .pp-distant-sky-balloon[data-balloon-id="B5"],',
      '#' + ID + ' .pp-distant-sky-balloon[data-balloon-id="B6"]',
      '{display:none!important;}}',
      '@media(prefers-reduced-motion:reduce){',
      '#' + ID + ' .pp-distant-sky-balloon img{animation:none!important;}}'
    ].join('');
  }

  function setSizes() {
    if (!instance || !instance.layer.isConnected) return;
    var width = instance.wrapper.clientWidth || window.innerWidth || 1024;
    var base = Math.min(480, Math.max(230, width * 0.285));
    for (var i=0;i<instance.balloons.length;i++) {
      var balloon = instance.balloons[i];
      balloon.node.style.width = (base * balloon.spec.scale).toFixed(1) + 'px';
    }
  }

  function resize() {
    if (resizeFrame) return;
    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame=0;
      setSizes();
    });
  }

  function remove() {
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
    resizeFrame = 0;
    if (instance && instance.layer) instance.layer.remove();
    instance = null;
  }

  function initialize() {
    if (!document.documentElement.classList.contains('pp-muse-secret-sky-page')) return;
    var sky = document.getElementById(skyId);
    var wrapper = document.querySelector('.page-wrapper');
    if (!sky || !wrapper || !wrapper.contains(sky)) return;
    if (instance && instance.sky === sky && instance.layer.isConnected) {
      setSizes(); return;
    }
    var urls = getAssetUrls();
    if (!urls) { report('Approved companion asset URLs not yet available; leaving the working site untouched.');return; }

    // Other House scripts retain complete ownership of their own DOM, styles,
    // and animation. This layer is a NEW decorative child of the sky only.
    remove();
    if (!document.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id=STYLE_ID;
      style.textContent=cssText();
      document.head.appendChild(style);
    }
    var layer = document.createElement('div');
    layer.id=ID;
    layer.setAttribute('aria-hidden','true');
    layer.setAttribute('data-background-depth','behind-birds-and-creatures');
    var balloons=[];
    for (var i=0;i<specifications.length;i++) {
      var spec=specifications[i];
      var node=document.createElement('div');
      node.className='pp-distant-sky-balloon';
      node.setAttribute('data-balloon-id',spec.id);
      node.style.left=spec.x+'%';
      node.style.top=spec.y+'%';
      node.style.opacity='1'; // No ghostly transparency; depth comes from size, position and drift.
      node.style.setProperty('--pp-duration',spec.duration+'s');
      node.style.setProperty('--pp-delay',spec.delay+'s');
      node.style.setProperty('--pp-drift',spec.driftX+'px');
      node.style.setProperty('--pp-neg-drift',(-spec.driftX)+'px');
      node.style.setProperty('--pp-drift-half',(spec.driftX/2)+'px');
      node.style.setProperty('--pp-up',(-spec.bobY)+'px');
      node.style.setProperty('--pp-down',(spec.bobY*0.32).toFixed(1)+'px');
      node.style.setProperty('--pp-up-half',(-spec.bobY*0.63).toFixed(1)+'px');
      node.style.setProperty('--pp-tilt',(spec.driftX>=0?1:-1)+'deg');
      node.style.setProperty('--pp-neg-tilt',(spec.driftX>=0?-.65:.65)+'deg');
      node.style.setProperty('--pp-tilt-half',(spec.driftX>=0?.4:-.4)+'deg');
      var img=document.createElement('img');
      img.src=urls[spec.design];
      img.alt='';
      img.setAttribute('aria-hidden','true');
      img.decoding='async';
      img.loading='eager';
      img.draggable=false;
      node.appendChild(img);
      layer.appendChild(node);
      balloons.push({node:node,spec:spec});
    }
    sky.appendChild(layer);
    instance={layer:layer,sky:sky,wrapper:wrapper,balloons:balloons};
    setSizes();
    report('Seven distant balloons installed inside the sky; existing four departure balloons untouched.');
  }

  window[NS]={
    version:VERSION,
    getStatus:function () {
      return {
        present:!!(instance && instance.layer.isConnected),
        desktopBalloons: instance ? instance.balloons.length : 0,
        onMobile:window.matchMedia && window.matchMedia('(max-width:767px)').matches,
        sources:'existing approved four companion balloon assets',
        modifiesMuseFlight:false
      };
    }
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',function(event){
    if (instance && event.target && (event.target.contains(instance.sky) || event.target === instance.sky)) remove();
  });
  window.addEventListener('resize',resize,{passive:true});
  window.addEventListener('pageshow',initialize);
})();
